import { Button, Tooltip } from "@material-ui/core";
import { FC } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { WordDocumentDownloadWhiteIcon } from "Views/Components/Icons/WordDocumentDownloadWhiteIcon";
import { WordMinutesDownloadWhiteIcon } from "Views/Components/Icons/WordMinutesDownloadWhiteIcon";

interface Props {
  downloadFile(fileTypeName: string): void;
  readonly fileType: string;
}

export const DownloadFileButton: FC<Props> = ({ downloadFile, fileType }) => {
  const { t } = useTranslation("audits");

  const handleDownloadFileClick = (fileType: string) => {
    const fileTypeName = fileType;
    downloadFile(fileTypeName);
  };

  return (
    <>
      {fileType === "MeetingMinutes" ? (
        <>
          <Tooltip
            title={t<string>("audits:downloadMinutesOfMeetingTemplate")+" (NOTE: Some file download features may be unavailable at the moment)"}
            arrow={true}
          >
            <Button onClick={() => handleDownloadFileClick(fileType)}>
              <WordMinutesDownloadWhiteIcon />
            </Button>
          </Tooltip>
        </>
      ) : fileType === "AuditReport" ? (
        <>
          <Tooltip
            title={t<string>("audits:downloadAuditReportTooltip")+" (NOTE: Some file download features may be unavailable at the moment)"}
            arrow={true}
          >
            <Button onClick={() => handleDownloadFileClick(fileType)}>
              <WordDocumentDownloadWhiteIcon />
            </Button>
          </Tooltip>
        </>
      ) : (
        <></>
      )}
    </>
  );
};
